export default __webpack_public_path__ + "static/media/login_bg_keto.4329818b.jpg";